import { render, staticRenderFns } from "./querenitem.vue?vue&type=template&id=665e854a&class=component&"
import script from "./querenitem.vue?vue&type=script&lang=js&"
export * from "./querenitem.vue?vue&type=script&lang=js&"
import style0 from "./querenitem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665e854a')) {
      api.createRecord('665e854a', component.options)
    } else {
      api.reload('665e854a', component.options)
    }
    module.hot.accept("./querenitem.vue?vue&type=template&id=665e854a&class=component&", function () {
      api.rerender('665e854a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/querenitem.vue"
export default component.exports